import { CatPopover } from '@blocks-react/components/Popover';
import cx from 'classnames';
import { ContactYourDealerPopoverProps } from '../../types';

export const ContactYourDealerPopover = ({
  popoverHeading,
  children,
  className,
  onBlMobileOverlayOpen,
  onBlMobileOverlayClose
}: ContactYourDealerPopoverProps) => {
  return (
    <CatPopover
      behavior="responsive"
      headingVariant="title-sm"
      heading={popoverHeading}
      className={cx('w-100', className)}
      position="auto"
      data-testid="contact_dealer_popover"
      onBlPopoverOpen={onBlMobileOverlayOpen}
      onBlPopoverClose={onBlMobileOverlayClose}
    >
      {children}
    </CatPopover>
  );
};
